import { Form, Input, Modal } from "antd";
import { BCAddCommentRequest } from "../../../Interfaces/BCAddCommentRequest";

type Props = {
    onOk: (request: BCAddCommentRequest) => Promise<void>;
    onCancel: () => void;
    isOpen: boolean;
    isLoading: boolean;
    orderNo: string;
    serviceItemLineNo: string;
}

const AddCommentModal = (props: Props) => {

    const [form] = Form.useForm();

    return (
        <Modal
            //className="astena-modal"
            open={props.isOpen}
            title={"Opmerking toevoegen"}
            okText="Toevoegen"
            confirmLoading={props.isLoading}
            cancelText="Annuleren"
            onCancel={props.onCancel}

            onOk={() => {
                form
                    .validateFields()
                    .then((values) => {
                        props.onOk({
                            comment: values.comment,
                            orderNo: props.orderNo,
                            serviceItemLineNo: Number(props.serviceItemLineNo)
                        })
                            .then(() => form.resetFields());

                    })
                    .catch((info) => {
                        //console.log('Validate Failed:', info);
                    });
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
                style={{ padding: 20 }}
            >

                <Form.Item
                    name="comment"
                    //label="Opmerking"
                    rules={[{ required: true, message: 'Opmerking verplicht' }]}
                >
                    <Input.TextArea maxLength={80} />
                </Form.Item>
            </Form>
        </Modal>

    );
};

export default AddCommentModal;